<template lang="pug">
  v-row
    v-col(cols=12)
      button-mode-stake-page(v-model="modeTab")
        v-btn(
          style="border-radius:8px;"
          @click="$emit('changeMode',MODE_STAKE_PANEL)"
        )
          v-icon(color="grey") mdi-skip-previous
          h5.grey--text {{ $t('button.back') }}
      v-card(
        flat 
        elevation="5"
        style="border-top-left-radius:0px;"
      )
        v-card-text(style="padding-top:0;")
          component(
            :is="curPage"
            :cur-item-room-history="curItemRoomHistory"
          )
</template>
<script> 
import ButtonModeStakePage from '../components/ButtonModeStakePage'
import TableListOrder from '../components/TableListOrder.vue'
import TableLastResult from '../components/TableLastResult.vue'
const MODE_STAKE_PANEL = 0
const MODE_ORDER_RESULT = 1
const MODE_LAST_RESULT = 2
export default {
  components: {
    ButtonModeStakePage, 
    TableListOrder,
    TableLastResult
  },
  props: {
    mode: {
      type: Number,
      default: () => 0
    },
    curItemRoomHistory: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    modeTab:0,
  }),
  computed: {
    curPage () {
      if(this.isOrderResultMode) {
        return 'table-list-order'
      } else {
        return 'table-last-result'
      }
    },
    isLastResultMode () {
      return this.modeTab === MODE_LAST_RESULT 
    },
    isOrderResultMode () {
      return this.modeTab === MODE_ORDER_RESULT
    },
    MODE_STAKE_PANEL: () => MODE_STAKE_PANEL
  },
  created () {
    this.modeTab = this.mode
  },
}
</script>